<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Reallocate Load Id</strong>
          </div>
          <div class="box" id="addform">
            <b-form
              @submit.prevent="validateForm('form-1')"
              data-vv-scope="form-1"
            >
              <b-row class="mb-4">
                <b-col md="6">
                  <b-form-group>
                    <b-row>
                      <b-col sm="4">
                        <label for="Select Vehicle Type"><b>Select Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span><b>&nbsp;&nbsp;:</b>
                      </b-col>
                      <b-col sm="8">
                        <b-form-select
                          v-model="selected_vehicaltype"
                          :options="vehicaloptions"
                          @change="vehicleTypeSelected(selected_vehicaltype)"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col md="5" class="pr-0">
                  <b-form-group>
                    <b-row>
                      <b-col sm="4">
                        <label for="Select Vehicle"><b>Select Vehicle</b></label>&nbsp;<span style="color: red;">*</span> <b>&nbsp;&nbsp;:</b>
                      </b-col>
                      <b-col sm="7">
                        <v-select v-model="customer.vehicle_id"  @change="focusInput()" :options="vehicleitems" :disabled="selected_vehicaltype.length == 0" 
                        placeholder="-- Select Vehicle Id --"></v-select>
                      </b-col>
                      <br>
                      <br>
                      <br>
                      <b-col sm="4">
                        <label for="Select Reason"><b>Select Reason</b></label>&nbsp;<span style="color: red;">*</span> <b>&nbsp;&nbsp;:</b>
                      </b-col>
                      <b-col sm="7">
                         <!-- select resoan start -->
                         <b-form-group>
                          <b-form-select v-model="selectedreason" name="Reason" class="mySelectBox" @input="checkOtherReason(selectedreason)">
                            <option :value="selected_reson">--Selected Reason-</option>
                        
                            <option value="Vehicle breakdown">Vehicle breakdown</option>
                            <option value="Transhipment">Transhipment</option>
                            <option value="Vehicle number not updated earlier">Vehicle number not updated earlier</option>
                            <option value="Incorrect Vehicle Number Updated">Incorrect Vehicle Number Updated</option>
                            <option value="Earlier planned vehicle space issue">Earlier planned vehicle space issue</option>
                            <option value="Other">Other</option>
                            
        
                          </b-form-select>     
                          <!-- <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i
                                class="fa fa-warning help text-danger"
                                v-show="errors.has('form-1.Reason')"
                                >{{ errors.first("form-1.Reason") }}</i
                              >
                            </span>
                          </b-input-group>                            -->
                        </b-form-group>
                        <!-- select resoan end -->
                      </b-col>
                      <b-col sm="12">
                        <b-form-group v-if="selectedReasonOther">
                          <b-row>
                            <b-col sm="5">
                              <label for="Select Reason"><b>ADD Other Reason</b></label>&nbsp;<span style="color: red;">*</span> <b>&nbsp;&nbsp;:</b>
                            </b-col>
                            <b-col sm="7" class="pl-0">
                              <b-form-input v-model="otherReasonText" placeholder="Enter Other Reason" name="other reason"></b-form-input>
                              <!-- <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                  <i
                                    class="fa fa-warning help text-danger"
                                    v-show="errors.has('form-1.other reason')"
                                    >{{ errors.first("form-1.other reason") }}</i
                                  >
                                </span>
                              </b-input-group>   -->
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12">
                        <div v-if="customer.vehicle_id">
                          <b-button  size="sm" @click="EwaybillList(customer.vehicle_id.key,'vehicle')" 
                             style="margin-left: 35%;" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Download Eway Bill 
                           </b-button>
                         </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>

                <b-col md="4" class="pl-0">
                  <b-form-group>
                    <b-row>
                      <b-col sm="3">
                        <label for="Load Id"><b>Load Id</b></label>&nbsp;<span style="color: red;">*</span><b>:</b>
                      </b-col>
                      <b-col sm="8">
                        <vue-tags-input
                          v-model="customer.shippingid"
                          :tags="tags"
                          @tags-changed="(newTags) => (tags = newTags)"
                          :avoidAddingDuplicates="avoidAddingDuplicates"
                          :placeholder="placeholder"
                          ref="taginput"
                          v-bind:separators="[',', ';']"
                        />
                        <span class="badge badge-success1">&nbsp;</span>&nbsp;
                        <label :label-cols="4">Unique Load Id</label><br />
                        <span class="badge badge-success2">&nbsp;</span
                        >&nbsp;&nbsp;<label :label-cols="4"
                          >Repeat/Duplicate Load Id
                        </label>

                        <span
                          v-show="errors.has('form-1.shipmentid')"
                          class="help text-danger"
                          >{{ errors.first("form-1.shipmentid") }}</span
                        >
                      </b-col>
                      </b-row>
                  </b-form-group>
                </b-col>

                <b-col md="3" class="text-right">
                  <b-button
                    :disabled="tags.length==0"
                    class="mr-1"
                    type="submit"
                    size="md"
                    variant="primary"
                    >Reallocate</b-button
                  >
                  <b-button
                    :disabled="disabled == 0"
                    @click="clear()"
                    size="md"
                    variant="danger"
                    >Clear</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>

          <b-col sm="12" class="text-right">
            <b-button variant="info" @click="refreshReallocateListing()"><i class="fa fa-refresh" aria-hidden="true"></i> Refresh</b-button>
            <p style="margin-top: 10px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
          </b-col>
          <b-table show-empty responsive   :items="Items" :busy="isBusy"    :current-page="currentPage"  :fields="Fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection" :bordered="bordered" > 
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
            <template slot="loadsreallocated" slot-scope="row">
              <div>
                <b-button variant="secondary" @click="LoadEwaybillList(row.item,'load')">{{row.item.loadsreallocated}}</b-button>
              </div>
            </template>
            <template slot="status" slot-scope="row">
              <div>
                <b-badge :variant="row.item.status==='Pending'?'danger':'success'">{{row.item.status==='Pending'?'Pending':'Updated'}}</b-badge>
              </div>
            </template>
          </b-table>
          <b-col md="12" class="my-1" >
            <paginate v-model="pageNum"
             :page-count="noofpages"
             :page-range="10"
             :margin-pages="2"
             :click-handler="clickCallback"
             :prev-text="'Prev'"
             :next-text="'Next'"
             :container-class="'pagination'"
             :page-class="'page-item'">
           </paginate>
         </b-col>  
          <div slot="footer" v-if="this.invalidshipppingid">
            <b-row>
              <b-col md="12">
                <span>
                  <h6>
                    Invalid Shipmemnts :
                    <strong> 12{{ invalidshipppingid }}</strong>
                  </h6>
                </span>
              </b-col>
            </b-row>
          </div>
        
          <b-modal v-model="openmodels" hide-footer title="Eway Bill Details" size="lg">
            <b-row>
              <b-col v-if="type==='load'">
                <b>Vehicle No. - </b>{{ LoadValue.vehicle_no==null||LoadValue.vehicle_no==undefined||LoadValue.vehicle_no==''?'':LoadValue.vehicle_no }}
              </b-col>
              <b-col>
                <div class="text-right">
                    <h6><b>Total Records : <span style="color: red;">{{ ewaybillitemLength }}</span></b></h6>
                </div>
              </b-col>
            </b-row>
            <div class="d-block text-center">
              <b-table show-empty responsive   :items="ewaybillitem" :busy="isBusyeway"    :fields="ewayfields"   :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div> 
                <template slot="ewaybillpdf" slot-scope="row">
                  <div style="    display: flex;
                  justify-content: start;
                  align-items: center;">
                   <a :href="row.item.ewaybillpdf" target="_blank"><b-button size="sm"> <i class="fa fa-download" aria-hidden="true"></i>
                    Download</b-button></a> &nbsp;&nbsp;&nbsp;
                    <b-badge variant="success" style="border-radius: 10px;" v-if="row.item.pushflag==='1' && type==='load'"><i class="fa fa-check" aria-hidden="true" style="font-size: 13px;"></i></b-badge>
                  </div>
                </template>
              </b-table>
            </div>
            <b-button class="mt-3 float-right" variant="danger" @click="hideModal">Close Me</b-button>
          </b-modal>
          
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
      selected_vehicaltype: "",
      vehicaloptions: [
        { value: "", text: "Please select an option" },
        { value: "Adhoc", text: "Adhoc" },
        { value: "Normal", text: "Normal" },
      ],
      name: "allocation",
      data: [],
      DAPendingStatus: [],
      customer: {
        vehicle_id: "",
      },
      toggleInfo: false,
      avoidAddingDuplicates: false,
      placeholder: "Add Load Id/Parent AWB",
      data1: "",
      selected: "",
      shippingid: "",
      invalidshipppingid: "",
      tags: [],
      disabled: "",
      selectedusertype: 0,
      value: "",
      vehicleitems: [],
      parentawbtag: [],
      vehicle_selectnumber :"",
      value_vehicleid :'',
      openmodels : false,
      ewaybillitem :[],
      ewayfields : [],
      isBusyeway : false,
      ewaybillitemLength:0,
      selectedreason:'',
      selected_reson:'',
      otherReasonText: '',
      selectedReasonOther : false,
      //-----------------------//
      Items:[],
      Fields:[
        { key: 'requestid', label: 'Request Sr. No.', sortable: true},
        { key: 'vehicle_no', label: 'Vehicle No.', sortable: true},
        { key: 'loadsreallocated', label:'Loads Reallocated',sortable: true},
        { key: 'createddate', label: 'Created Date and Time', sortable: true},          
        { key: 'createdby', label: 'Created By', sortable: true },    
        { key: 'vehicle_type', label: 'Vehicle Type', sortable: true },
        { key: 'reason', label: 'Reason', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
      isBusy:false,
      perPage:20,
      filter:null,
      sortBy:null,
      sortDesc:false,
      sortDirection:'asc',
      bordered:true,
      totalRows:0,
      noofpages:'',
      pageNum:1,
      requestid:0,
      type:'',
      LoadValue:[],
      accessBody:[],
      isReadOnly:false,
    }
  },
  created: function() {
    var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
      console.log("--------->>>>>>>>>>",userInfo.body)
      this.ischeckbodyvalidation();
    this.reallocateListing(this.pageNum);
  },
  computed: {
    serveur() {
      // alert('ss');
      return this.customer.deliveryagentmasterid;
    },
    code() {
      // alert('cc');
      return this.customer.usertype;
    },
  },
  methods: {
    ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        // if (element.title=='Reallocate Shipment' && element.isReadonly==true && this.route_id=='normal') {
        //   this.isReadOnly=true
        // }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='Reallocate Shipment' && k.isReadonly==true) {
            this.isReadOnly=true
          }
        }
       }
      }
      console.log(" this.isReadOnly", this.isReadOnly)
    },
    checkOtherReason(value) {
      if (value=='Other') {
        this.selectedReasonOther=true;
      }
      else{
        this.otherReasonText='';
        this.selectedReasonOther=false;
      }
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.isReadOnly) {
            this.$fire({
              text: 'You have only read only access of this feature',
              type: "warning",
              timer: 30000,
            });
            return false;
            
          }
          this.reallocate()
          this.toggleInfo = !this.toggleInfo;
        }
      });
    },

    focusInput() {
      this.$refs.taginput.$refs.newTagInput.focus();
      this.disabled = 1;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);


      const shipmentstatusObj = {
        vehicleid: this.customer.vehicle_id? this.customer.vehicle_id.key:"",
        shipmentstatus: "BookingDone",
      };
      console.log("shipmentstatusObj", shipmentstatusObj);
      // console.log("customer",this.customer.vehicle_id.length);
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getShipmentStatusListVehicleWise`,
          shipmentstatusObj
        )
        .then((result) => {
          console.log("YYY", result);
        })
        .catch((ex) => {
          console.log("error", ex);
        });
        // this.EwaybillList();
    },

    closemodal: function() {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo;
    },

    clear: function() {
      this.tags = [];
      this.customer = {
        vehicle_id:"",
      };
      // this.customer.vehicle_id = this.selected;
      this.invalidshipppingid = "";
      this.parentawbtag = [];
      this.selected_vehicaltype = "";
      this.selectedreason = "";
      this.otherReasonText = '';
      // this.errors.clear("form-1");
    },

    GetSortOrder: function(prop) {
      return function(a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },

    vehicleTypeSelected(type) {
      if (type != "") {
        let selectedType = type;
        this.customer.vehicle_id = "";
        this.displaydata(selectedType);
      } else {
        this.customer.vehicle_id = "";
      }
    },

    displaydata: function(selectedType) {
      console.log("selected_vehicaltype", selectedType);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.vehicleitems=[];
      const deliveryagentobj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        vehicle_type: selectedType,
        isactive: "1",
      };
      console.log("deliveryagentobj", deliveryagentobj);
      // return false;
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
          deliveryagentobj
        )
        .then((result) => {
          console.log("YYY", result);
          if (result.body.length > 0) {
            // this.isBusy = !this.isBusy
            this.data = result.body;
            // var vehicaldata = result.body;
            this.vehicleitems = result.body;
            var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.vehicle_id,
                  label:srData.vehicle_no
                });
              });
              this.vehicleitems = data;
          } else {
            this.data = result.body;
            this.vehicleitems = result.body;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    reallocate() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
    
      var load_id = [];
            this.parentawbtag = [];

      for (let i = 0; i < this.tags.length; i++) {
        load_id = this.tags[i].text;
        this.parentawbtag.push(load_id);
      }

      if (this.selected_vehicaltype==null || this.selected_vehicaltype=='') {
        this.$fire({
              text: 'Please Select Vehicle Type',
              type: "warning",
              timer: 30000,
            });
            return false;
      }

      if (this.customer.vehicle_id==null || this.customer.vehicle_id=='') {
        this.$fire({
              text: 'Please Select Vehicle Number',
              type: "warning",
              timer: 30000,
            });
            return false;
      }
      var select_reason = ''
      if (this.selectedreason=='Other') {
        select_reason = this.otherReasonText;
      }
      else{
        select_reason = this.selectedreason;
      }

      console.log("select_reason",select_reason)
      if (select_reason==null || select_reason=='') {
        this.$fire({
              text: 'Please Select Reason',
              type: "warning",
              timer: 30000,
            });
            return false;
      }

      const Obj = {
        vehicleid: this.customer.vehicle_id.key,
        parentawb: this.parentawbtag,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
        reason:`${select_reason}`,
        sysusermasterid: `${userInfo.sysusermasterid}`
      };
      console.log("Obj", Obj);
      // return false
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/consignmentMasterReallocateAwb`,
          Obj
        )
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.EwaybillList(this.customer.vehicle_id.key,'vehicle');
            this.otherReasonText ='';
            this.selectedreason ='';
            this.customer ={};
            this.tags = [];
            this.parentawbtag = [];
            this.selected_vehicaltype='';
            // this.errors.clear("form-1");
            this.pageNum=1;
            this.reallocateListing(this.pageNum);
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        });
    },

    EwaybillList : function (value,type) {
      this.ewayfields = [];
      this.ewayfields = [
          {key:'parentawb', label : 'Parent AWB'},
          {key:'ebn', label : 'EBN'},
          {key:'invoiceno', label : 'Invoice No'},
          {key:'ewaybillpdf', label : 'Eway Bill PDF'}
        ]
      this.openmodels=true;
      this.type='';
      this.type=type;
      this.customer.vehicle_id.key=value;
      this.EwaybillDownloadList();
    },
    EwaybillDownloadList: function () {
      this.isBusyeway=true;
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const Obj={
          tripid: `${this.customer.vehicle_id.key}`,
        }
        console.log("obj",Obj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownload`,Obj).then((result)=>{
            console.log("Result",result);
            this.isBusyeway=false;
            if (result.body.returnmsg === 'Successful') {
              this.ewaybillitem=result.body.returnvalue;
              this.ewaybillitemLength=result.body.returnvalue.length;
            }else{
              this.ewaybillitem=[];
              this.ewaybillitemLength=0;
            }
        })
    },

    hideModal : function(){
      this.openmodels = false;
      this.parentawbtag = [];
    },

    refreshReallocateListing(){
      this.pageNum=1
      this.reallocateListing(this.pageNum);
    },

    clickCallback (pageNum){
        this.listingpageno = pageNum;
         this.reallocateListing(pageNum);
    },

    reallocateListing : function (pageNo) {
      this.Items=[];
      this.totalRows =0;
      this.isBusy=true;
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

        const Obj={
          pageno: pageNo,
        }
        console.log("obj",Obj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getReallocationRequestsList`,Obj).then((result)=>{
            console.log("Result",result);
            this.isBusy=false;
            if (result.body.returnmsg === 'Successful') {
              this.Items=result.body.returnvalue;
              this.totalRows = result.body.totalcount;
              this.noofpages=parseInt(this.totalRows)/10;
              this.noofpages=Math.ceil( this.noofpages);
            }else{
              this.Items=[];
              this.totalRows =0;
            }
        })
    },

    LoadEwaybillList : function (value,type) {
      this.ewayfields = [];
      this.ewayfields = [
          {key:'parentawb', label : 'Parent AWB'},
          {key:'ebn', label : 'EBN'},
          {key:'invoiceno', label : 'Invoice No'},
          {key:'invoicevalue', label : 'Invoice Value'},
          {key:'ewaybillpdf', label : 'Eway Bill PDF'}
        ];
      this.openmodels=true;
      this.type='';
      this.requestid='';
      this.LoadValue=[];
      this.LoadValue=value;
      this.requestid=value.requestid;
      this.type=type;
      this.LoadEwaybillDownloadList();
    },
    LoadEwaybillDownloadList: function () {
      this.isBusyeway=true;
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const Obj={
          requestid: this.requestid,
        }
        console.log("obj",Obj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getReallocationRequestsLoads`,Obj).then((result)=>{
            console.log("Result",result);
            this.isBusyeway=false;
            if (result.body.returnmsg === 'Successful') {
              this.ewaybillitem=result.body.returnvalue;
              this.ewaybillitemLength=result.body.returnvalue.length;
            }else{
              this.ewaybillitem=[];
              this.ewaybillitemLength=0;
            }
        })
    },

  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style>
.badge-success1 {
  background-color: #5c6bc0;
  color: #fff;
}
.badge-success2 {
  background-color: #e54d42;
  color: #fff;
}
</style>
